import { useTranslations } from 'next-intl';

import Card from '@commons/components/Card';
import DrupalImage from '@commons/components/Image/Drupal';
import TopoPatternImage from '@commons/components/Image/TopoPattern';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import { useFormattedDate } from '@commons/hooks/useFormattedDate';
import { Link } from '@commons/i18n/navigation';
import { CARD_DISPLAY_IMAGE_SIZES } from '@commons/pagebuilder/nodes/images';

import type { PodcastNodeProps } from '.';

/**
 * Podcast node component for the Card display type.
 */

const PodcastNodeCard = (props: PodcastNodeProps) => {
  const t = useTranslations();

  const { image, title, summary, authors, date, alias, format } = props;

  const upperTitle = format ? format.name : t('nodes.podcast.label');

  const formattedDate = useFormattedDate(date);

  const renderedImage = image ? (
    <DrupalImage {...image} sizes={CARD_DISPLAY_IMAGE_SIZES} />
  ) : (
    <TopoPatternImage alt={title} sizes={CARD_DISPLAY_IMAGE_SIZES} />
  );

  return (
    <Link href={alias}>
      <Card gap="md" justify="space-between" hasBorder>
        <Flex gap="xs" direction="column">
          <Card.Overlay>{renderedImage}</Card.Overlay>
          <Text as="h6" level="label-md" transform="uppercase" marginBottom="none">
            {upperTitle}
          </Text>
          <Card.Title>{title}</Card.Title>
          {summary && <Text marginBottom="none">{summary}</Text>}
          {authors && (
            <Text level="body-sm" marginBottom="none">
              {t('commons.by', { author: authors })}
            </Text>
          )}
        </Flex>
        <Text level="body-xs" transform="uppercase" marginBottom="none">
          {formattedDate}
        </Text>
      </Card>
    </Link>
  );
};

export default PodcastNodeCard;
